package ui.home

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.task.domain.model.TaskModel
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

data class HomeState(
    val getProfile: State<ProfileModel> = State(),
    val getTodayTodoTask: State<List<TaskModel>> = State(),
    val globalIsLoading: MutableState<Boolean> = mutableStateOf(false),
    val openFirstTimeDialog: Boolean = false,
) {
    val getFilteredTodayTodoTask
        get() = getTodayTodoTask.data.orEmpty().filter { task ->
            val todayDate = Clock.System.now()
                .toLocalDateTime(TimeZone.UTC).date.toString()

            task.dueDate == todayDate &&
                task.status == TaskModel.Status.Todo
        }
}
